import React, { useState } from "react";
import { jwtDecode } from "jwt-decode";
import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { useDispatch } from 'react-redux';
import FormInput from "../form-input/form-input.component";
import Button from "../button/button.component";
import OTPPopup from "../otp/otp.component";
import { superAdminLogin } from "../../services/super-admin.service";
import { brandLogin } from "../../services/merchant.service";
import { useNavigate, useLocation } from "react-router-dom";
// import BrandingComponent from "../brand_register/brand_register.component";
import { setCurrentUser } from "../../store/user/user.reducer";
import Eyehide from "../../assets/images/eye_hide.svg";
import Eyeshow from "../../assets/images/eye_show.svg";
import { signAuthByEmailAndPassword } from "../../services/Authentication.service";
import { useFormik } from "formik";
import * as Yup from "yup";
import  oneEyeLogo  from "../../assets/images/applogo.webp";
//import toast from "react-hot-toast";

// import './sign-in-form.styles.scss';

const defaultFormFiled = {
  username: "",
  password: "",
};

const SignInForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const userType = 'admin';

  const [formFiled, setFormField] = useState(defaultFormFiled);
  const [otpPopup, setOtpPopup] = useState(false);
  const [show, setShow] = useState(false);
  const [passwordVisibilty, setPasswordVisibilty] = useState(false)



  const { email, password } = formFiled;

  const changeField = (event) => {
    const { name, value } = event.target;
    setFormField({ ...formFiled, [name]: value });
  };
  // const resetForm = () => {
  //   setFormField(defaultFormFiled);
  // };

  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   try {
  //     // alert(123);
  //     const payload = {
  //       "id":"9",
  //       "username": values.name,
  //       "password":req.password,
  //       "active": 1,
        
  //     }
  //      const { user } = await signAuthByEmailAndPassword();
  //     // console.log(email, password)
  //     let decodedToken = {}
  //     decodedToken['userDetail'] = {"userType":"admin"};
  //     const req = { email, password };
  //     if (req.email == 'admin@test.com' && req.password=='welcome') {
  //       dispatch(setCurrentUser(decodedToken));
  //       navigate(`/${userType}/dashboard`)
  //     } else {
  //       toast.error("Invalid-Login");
  //     }
  //   } catch (error) {
  //     if (error?.message) {
  //       const msg = error?.message?.split(":")?.[1]?.trim();
  //       console.error(msg)

  //     }
  //     console.log(error.message);
  //   }
  // };

  const onClose = () => {
    console.log("closed");
    setOtpPopup(false);
  };




  const brandRegisterOnClose = (cond) => {
    console.log("closed");
    setShow(false);
    if (cond) {
      setOtpPopup(true);

    }
  };

   // form 

   const { handleBlur, handleChange, handleSubmit, values, errors, touched, resetForm, setErrors } = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    // validationSchema: Yup.object({
    //     name: Yup.string()
    //         .max(50, "Project Name must be at most 50 characters")
    //         .required("Project Name is required"),
    //         typeId: Yup.string().required("Type is required"),
    // }),
    onSubmit: async (values, { resetForm }) => {
        try {
              const payload = {
                "username": values.username,
                "password":values.password,
              }
            const res = await signAuthByEmailAndPassword(payload)
    

            if (res?.status === 200) {
                toast.success("Login Successfull")
                let decodedToken = {}
                decodedToken['userDetail'] = {"userType":res.data.role ,"user": res.data};
                resetForm();
                // setErrors({});
                // back()
                dispatch(setCurrentUser(decodedToken));
                navigate(`/${userType}/dashboard`)

            } else {
              toast.error("Invalid-Login");
            }
        } catch (error) {
            if (error?.message) {
                const msg = error?.message?.split(":")?.[1]?.trim();
                console.error(msg)


            }
            console.log(error.message);
        }
    },
});


  return (
    // <div className='sign-up-container'>
    //     <h2>Sign-in using email and password</h2>
    //     {/* <span>Sign-in using email and password</span> */}
    //     <form onSubmit={(event) => { handleSubmit(event) }} >
    //         <FormInput required={true} label={'Email'} type='email' name='email' value={email} onChange={changeField} />
    //         <FormInput required={true} label={'password'} type='password' name='password' value={password} onChange={changeField} />
    //         <div className='buttons-container'>
    //             <Button type='submit'>SignIn</Button>
    //         </div>
    //     </form>
    //     <OTPPopup show={otpPopup} onClose={onClose} />

    // </div>
    <div className="accountWrapper">
      <div className="loginFrame">
        <img className="Krtilogo" src={oneEyeLogo } alt="Project-Status"/>

        <h5 className="fontSize20 fontWeight600 blackClr_text textalign_center">Sign in to account</h5>
        <p className="fontSize14 fontWeight400 SteelWoolClr_text textalign_center mb_24">Enter your email & password to login</p>
        <form
          onSubmit={(event) => {
            handleSubmit(event);
          }}
        >
          <FormInput
            required={true}
            label={"Email Address"}
            placeholder="Email Address"
            type="text"
            name="username"
            value={values.username}
            onBlur={handleBlur}
             onChange={handleChange}
          />
          {/* <FormInput
            required={true}
            label={"Password"}
            type="password"
            name="password"
            value={password}
            onChange={changeField}
          /> */}

          <label className="fontSize14 fontWeight500 blackClr_text display_block mb_8">
            Enter the Passworddd
          </label>
          <div className="Groupinput mb_24">

            <input

              required={true}
              id="password"
              type={passwordVisibilty ? "text" : "password"}
              name="password"
              value={values.password}
              onBlur={handleBlur}
              onChange={handleChange}

              placeholder="Enter Password"
            // label={"Email Address"}

            />

            <div className="inputgroup_append">
              <span className="Groupinput_text">
                <button
                  type="button"
                  className="emptyBtn"
                  onClick={() => setPasswordVisibilty(!passwordVisibilty)}
                >

                  {passwordVisibilty ? (
                    <img src={Eyeshow} alt="Eyeshow" />
                  ) : (
                    <img src={Eyehide} alt="Eyehide" />
                  )}
                </button>
              </span>
            </div>
          </div>




          {/* <p className="textalign_right fontSize14 fontWeight500 mb_16 SteelWoolClr_text cursorPointer" onClick={() => navigate('/forgot-password')} >
            Forgot Password ?
          </p> */}
          <div className="buttons-container">
            <div className=" displayFlex alignItem_center gap12">
              <Button type="submit">SignIn</Button>
              {/* <Button type="button" onClick={handleShow} >Sign up</Button> */}

            </div>
            {/* <Button type="submit">SignIn</Button>  <br />
            <Button type="button" onClick={handleShow} >Sign up</Button> */}
          </div>
        </form>
        <OTPPopup show={otpPopup} onClose={onClose} />
        {/* <BrandingComponent show={show} onClose={brandRegisterOnClose} /> */}
      </div>
    </div>
  );
};

export default SignInForm;
